import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import BaseNumber from '../number';
import Text from '../../text';
import createChangeIndicatedComponent from '../create-change-indicated-component';
import omit from 'lodash/omit';

import { renderFormattedValue } from '../utils';

function SimpleNumber(props) {
  const value = (typeof props.value === 'number') ?
    Math.abs(props.value) : props.value;

  return (
    <Text {...props.renderProps}>
      <BaseNumber
        {...omit(props, 'value')}
        value={value}
      >
        {(txt) => renderFormattedValue(txt, props)}
      </BaseNumber>
    </Text>
  );
}

SimpleNumber.defaultProps = {
  withPlusSign: false,
};

SimpleNumber.propTypes = {
  ...Text.propTypes,
  ...BaseNumber.propTypes,
  withPlusSign: PropTypes.bool,
};

export default pure(SimpleNumber);
export const ChangeIndicatedNumber = pure(createChangeIndicatedComponent(SimpleNumber));
